<template>
  <div id="consultarAvisosWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Manifestações" breakpoint="md" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form
            @submit.stop.prevent="filtrarAvisos"
            @reset.prevent="limparFiltros"
          >
            <b-row>
              <b-col cols="12" md="6" xl="4">
                <b-form-group
                  label="CPF"
                  label-for="input-cpf"
                  label-class="text-left"
                >
                  <b-form-input
                    id="input-cpf"
                    v-model="filtro.filtroUsuario"
                    :disabled="cpfFixoUsuarioLogado"
                    :readonly="cpfFixoUsuarioLogado"
                    placeholder="CPF do manifestante"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group
                  label="Número/Ano"
                  label-for="input-numero"
                  label-class="text-left"
                >
                  <span class="d-flex flex-row" style="font-size: 24px">
                    <b-form-input
                      id="input-numero"
                      v-model="filtro.filtroNumero"
                      placeholder="Número"
                      type="number"
                      min="1"
                    />
                    &nbsp;/&nbsp;
                    <b-form-input
                      id="input-ano"
                      v-model="filtro.filtroAno"
                      placeholder="Ano"
                      type="number"
                      min="1950"
                      max="2100"
                    />
                  </span>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group
                  label="Assunto"
                  label-for="select-assunto"
                  label-class="text-left"
                >
                  <b-overlay :show="loadingAssunto">
                    <b-form-select
                      id="select-assunto"
                      :options="listaAssunto"
                      v-model="filtro.filtroAssunto"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group
                  label="Tipo"
                  label-for="select-status"
                  label-class="text-left"
                >
                  <b-overlay :show="loadingStatus">
                    <b-form-select
                      id="select-status"
                      :options="listaStatus"
                      v-model="filtro.filtroStatus"
                    />
                  </b-overlay>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group
                  label-size="md"
                  label-class="text-left"
                  label="Data da inicial da manifestação"
                  label-for="input-data-criacao"
                >
                  <b-form-datepicker
                    id="input-data-criacao"
                    v-bind="datePickerProps"
                    v-model="filtro.dataCriacaoInicio"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" xl="4">
                <b-form-group
                  label-size="md"
                  label-class="text-left"
                  label="Data da final da manifestação"
                  label-for="input-data-fim-criacao"
                >
                  <b-form-datepicker
                    id="input-data-fim-criacao"
                    v-bind="datePickerProps"
                    v-model="filtro.dataCriacaoFim"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" class="pt-4">
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  class="mr-2"
                  type="reset"
                >
                  <font-awesome-icon icon="redo" class="mr-2" />
                  Limpar Filtros
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-secondary"
                  type="submit"
                  :disabled="loadingAssunto || loadingStatus"
                >
                  <font-awesome-icon icon="filter" class="mr-2" />
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>
        <b-table
          :busy="isBusy"
          :fields="fields"
          hover
          no-border-collapse
          :items="items"
          :sort-desc="true"
          striped
          small
          per-page="0"
          :current-page="currentPage"
          stacked="lg"
          show-empty
        >
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-md-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item
                @click="visualizarManifestacao(row.item.IdManifestacao)"
              >
                <font-awesome-icon icon="eye" />
                <span> Detalhes</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="!somenteVisualizacao"
                @click="openModalProrrogar(row.item)"
              >
                <font-awesome-icon icon="fa-clock" />
                <span> Prorrogar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="!somenteVisualizacao"
                @click="
                  alertaAprovarManifestacao(row.item, 'geraração de protocolo')
                "
              >
                <font-awesome-icon icon="edit" />
                <span> Gerar Protocolo</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="!somenteVisualizacao && row.item.Concluida === false"
                @click="alertaAprovarManifestacao(row.item, 'conclusão')"
              >
                <font-awesome-icon icon="check" />
                <span> Concluir</span>
              </b-dropdown-item>
            </b-dropdown>
            <div
              class="actions-icons lgvert d-none d-md-flex justify-content-center"
            >
              <b-link
                class="text-dark"
                @click="visualizarManifestacao(row.item.IdManifestacao)"
              >
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Detalhes</div>
              </b-link>
              <b-link
                v-if="!somenteVisualizacao"
                class="text-dark"
                @click="openModalProrrogar(row.item)"
              >
                <font-awesome-icon icon="fa-clock" />
                <div style="font-size: 12px">Prorrogar</div>
              </b-link>
              <b-link
                v-if="!somenteVisualizacao"
                class="text-dark"
                @click="
                  alertaAprovarManifestacao(row.item, 'geraração de protocolo')
                "
              >
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Gerar Protocolo</div>
              </b-link>
              <b-link
                class="text-dark"
                @click="alertaAprovarManifestacao(row.item, 'conclusão')"
                v-if="!somenteVisualizacao && row.item.Concluida === false"
              >
                <font-awesome-icon icon="check" />
                <div style="font-size: 12px">Concluir</div>
              </b-link>
            </div>
          </template>
        </b-table>
        <table-pagination
          v-if="totalRows"
          :total-rows="totalRows"
          :per-page="perPage"
          @pageChange="pageChange"
        />
      </b-card-body>
    </b-card>

    <ModalProrrogarManifestacao
      v-if="modalAbertoProrrogar"
      :titulo="titulo"
      :manifestacao="manifestacaoComponete"
      @close="closeModalProrrogar"
      @reload="filtrarAvisos"
    />
  </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
import { fieldsManifestacoes } from "@/types/administracao/ouvidoria/fields-manifestacoes";
import { FiltrosManifestacoes } from "@/types/administracao/ouvidoria/filtros-manifestacoes";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue, Watch } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { Manifestacao } from "@/types/administracao/ouvidoria/manifestacao";
import { SelectValue } from "@/types/select-value";
import { AssuntoManifestacao } from "@/types/administracao/ouvidoria/assunto-manifestacao";
import { StatusManifestacao } from "@/types/administracao/ouvidoria/status-manifestacao";
import { PortalError } from "@/types/portal-error";
import ModalProrrogarManifestacao from "@/components/administracao/ouvidoria/ModalProrrogarManifestacao.vue";

const ROTA_CONSULTAR_MANIFESTACOES_MURAL = "/mural-avisos/manifestacoes";
const ROTA_CONSULTAR_MANIFESTACOES_OUVIDORIA =
  "/administracao/ouvidoria/consultar-manifestacoes";
const ROTA_VISUALIZAR_MANIFESTACAO_MURAL = "mural-avisos--visualiza-manifestacao";
const ROTA_VISUALIZAR_MANIFESTACAO_OUVIDORIA =
  "administracao--visualiza-manifestacao";

const CompProps = Vue.extend({
  name: "ConsultarManifestacoes",
  components: {
    CardFiltrosBusca,
    HeaderSagres,
    TablePagination,
    ModalProrrogarManifestacao,
  },
  props: {
    somenteVisualizacao: {
      type: Boolean,
      default: false,
    },
    cpfFixoUsuarioLogado: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class ConsultarManifestacoes extends mixins(UtilsTS, CompProps) {
  datePickerProps = DatePickerDefaultProps;
  fields: TableField[] = fieldsManifestacoes;
  filtro: FiltrosManifestacoes = new FiltrosManifestacoes();
  isBusy = true;
  modalAbertoProrrogar = false;
  perPage = 10;
  currentPage = 1;
  totalRows = 0;

  manifestacaoComponete: Manifestacao;
  titulo = "";

  items: Manifestacao[] = [];
  ugSelecionada: any = null;

  listaAssunto: SelectValue[] = [];
  listaStatus: SelectValue[] = [];

  loadingAssunto = true;
  loadingStatus = true;

  async pageChange(value: number): Promise<void> {
    try {
      this.isBusy = true;
      this.currentPage = value;

      this.aplicarCpfUsuarioLogado();

      if (this.filtro.filtroUsuario)
        this.filtro.filtroUsuario =
          this.apenasNumeros(this.filtro.filtroUsuario) ?? "";
      const response = await ouvidoriaService.filtraManifestacoes(
        this.currentPage,
        this.filtro
      );
      this.items = response.manifestacoes.map((m: any) => {
        return new Manifestacao(m);
      });
      this.totalRows = response.totalRows;
    } catch (error: unknown) {
      this.tratarError(error);
      this.items = [];
    } finally {
      this.isBusy = false;
    }
  }

  async visualizarManifestacao(id: number): Promise<void> {
    try {
      await this.$router.push({
        name: this.getNomeRotaVisualizarManifestacao(),
        params: { idManifestacao: String(id) },
      });
    } catch (error: unknown) {
      this.$toast.error("Erro ao redirecionar tela");
      throw new PortalError(`Erro ao redirecionar tela: ${error}`);
    }
  }

  async gerarProtocolo(id: number): Promise<void> {
    try {
      const response = await ouvidoriaService.gerarProtocolo(id);
      this.$toast.success(
        "Ouvidoria protocolada com sucesso! Protocolo: " + (await response)
      );
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  async filtrarAvisos(): Promise<void> {
    await this.pageChange(1);
  }

  limparFiltros(): void {
    this.filtro.limpar();
    this.aplicarCpfUsuarioLogado();
  }

  aplicarCpfUsuarioLogado(): void {
    if (!this.cpfFixoUsuarioLogado) return;

    const cpfLogado = localStorage.getItem('cpf') ?? '';
    this.filtro.filtroUsuario = this.apenasNumeros(cpfLogado) ?? '';
  }

  async getListaAssunto(): Promise<void> {
    try {
      this.loadingAssunto = true;
      const response = await ouvidoriaService.getAllAssunto();
      this.listaAssunto = response.map((a: AssuntoManifestacao) => {
        return { text: this.capitalize(a.DescAssunto), value: a.IdAssunto };
      });
      this.listaAssunto.unshift({ value: null, text: "Selecione o assunto" });
      this.filtro.filtroAssunto = null;
    } catch (error: unknown) {
      this.tratarError(error);
      this.listaAssunto = [];
    } finally {
      this.loadingAssunto = false;
    }
  }

  async getListaStatus(): Promise<void> {
    try {
      this.loadingStatus = true;
      const response = await ouvidoriaService.getAllStatus();
      this.listaStatus = response.map((s: StatusManifestacao) => {
        return { text: this.capitalize(s.Status), value: s.CodStatus };
      });
      this.listaStatus.unshift({ value: null, text: "Selecione o tipo" });
      this.filtro.filtroStatus = null;
    } catch (error: unknown) {
      this.tratarError(error);
      this.listaStatus = [];
    } finally {
      this.loadingStatus = false;
    }
  }

  alertaAprovarManifestacao(
    manifestacao: Manifestacao,
    comando: "conclusão" | "geraração de protocolo"
  ) {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja operar a ${comando} na manifestação ${manifestacao.Numero}/${manifestacao.Ano}?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          okVariant: "secondary",
          title: this.capitalize(comando),
        }
      )
      .then(async (value) => {
        if (value) {
          if (comando === "geraração de protocolo") {
            this.gerarProtocolo(manifestacao.IdManifestacao);
            return;
          }
          await this.concluirManifestacao(manifestacao.IdManifestacao);
        }
      })
      .catch((err) => {
        console.error(`Erro ao operar o diálogo de alerta`, err);
      });
  }

  async concluirManifestacao(idManifestacao: number) {
    try {
      this.isBusy = true;
      const response = await ouvidoriaService.concluirManifestacao(
        idManifestacao
      );
      if (!response) {
        this.$toast.error("Erro ao concluir manifestação");
        return;
      }
      this.$toast.success("Manifestação concluída com sucesso");
      await this.filtrarAvisos();
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.isBusy = false;
    }
  }

  openModalProrrogar(manifestacao: Manifestacao): void {
    try {
      this.isBusy = true;
      this.manifestacaoComponete = new Manifestacao(manifestacao);
      this.titulo = `Prorrogar Manifestação ${manifestacao.Numero}/${manifestacao.Ano}`;
      this.modalAbertoProrrogar = true;
    } catch (error) {
      console.error(error);
    } finally {
      this.isBusy = false;
    }
  }

  closeModalProrrogar(): void {
    this.modalAbertoProrrogar = false;
  }

  isRotaConsultarManifestacoesMural(path: string): boolean {
    return path.startsWith(ROTA_CONSULTAR_MANIFESTACOES_MURAL);
  }

  isRotaConsultarManifestacoesOuvidoria(path: string): boolean {
    return path.startsWith(ROTA_CONSULTAR_MANIFESTACOES_OUVIDORIA);
  }

  mudouEntreContextosConsultarManifestacoes(
    newPath: string,
    oldPath: string
  ): boolean {
    return (
      (
        this.isRotaConsultarManifestacoesMural(oldPath) &&
        this.isRotaConsultarManifestacoesOuvidoria(newPath)
      ) ||
      (
        this.isRotaConsultarManifestacoesOuvidoria(oldPath) &&
        this.isRotaConsultarManifestacoesMural(newPath)
      )
    );
  }

  getNomeRotaVisualizarManifestacao(): string {
    return this.somenteVisualizacao
      ? ROTA_VISUALIZAR_MANIFESTACAO_MURAL
      : ROTA_VISUALIZAR_MANIFESTACAO_OUVIDORIA;
  }

  @Watch("$route.path")
  async onRoutePathChange(newPath: string, oldPath: string): Promise<void> {
    if (!this.mudouEntreContextosConsultarManifestacoes(newPath, oldPath)) return;

    this.currentPage = 1;
    this.modalAbertoProrrogar = false;
    this.filtro.limpar();
    this.aplicarCpfUsuarioLogado();
    await this.filtrarAvisos();
  }

  async mounted(): Promise<void> {
    this.aplicarCpfUsuarioLogado();
    this.getListaAssunto();
    this.getListaStatus();
    this.filtrarAvisos();
  }
}
</script>
